import { Component, OnInit } from '@angular/core';
import { DentureDetailsUtils } from '@modules/denture-details/utils/denture-details-utils';
import { RxForModelingFacade } from '@modules/rx-for-modeling/rx-for-modeling.facade';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { RoleTypeEnum } from '@shared/models/role-type';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-rx-for-modeling',
	templateUrl: './rx-for-modeling.component.html',
	styleUrls: ['./rx-for-modeling.component.scss'],
	providers: [RxForModelingFacade]
})
export class RxForModelingComponent extends BaseDestroyableComponent implements OnInit {
	isRestoOrder$: Observable<boolean> = this.facade.isRestoOrder$;
	isProcedureFlow$: Observable<boolean> = this.facade.isProcedureFlow$;
	isDentureDetailsVisible$: Observable<boolean> = this.facade.isDentureDetailsVisible$;
	isNotesVisible$: Observable<boolean> = this.facade.isNotesVisible$;
	role: RoleTypeEnum = RoleTypeEnum.Technician;
	rx$ = this.facade.rx$;
	procedureId$ = this.facade.procedureId$.pipe(filter((id): id is number => id !== null && id !== undefined));

	isDentureDetailsVisible(procedureId: number): boolean {
		return DentureDetailsUtils.isDentureDetailsEnabled(procedureId);
	}

	constructor(private readonly facade: RxForModelingFacade) {
		super();
	}

	ngOnInit(): void {
		this.facade.syncModelingReadOnly$.pipe(takeUntil(this.componentAlive$)).subscribe();
	}
}
